/* eslint-disable react/prop-types */
import React from 'react';
import EmptyState from '../../active-users/states/EmptyState';
import ErrorState from '../../active-users/states/ErrorState';
import TableSkeleton from '../../active-users/states/TableSkeleton';

// Shared loading / error / empty renderers so every tab presents the same states.
export const TabLoading = () => (
  <div className="au-panel"><TableSkeleton rows={6} /></div>
);

export const TabError = ({ onRetry }) => (
  <ErrorState message="We couldn’t load this tab. Please try again." onRetry={onRetry} />
);

export const TabEmpty = ({ title = 'Nothing to show', message, icon = '📭' }) => (
  <EmptyState title={title} message={message} icon={icon} hasFilters={false} />
);
